import Cookies from "js-cookie";

type PageType = "product" | "event" | "category" | "cart" | "checkout";

type PageViewPayloadParams = {
  salesChannel: string;
  customerUuid?: string | null;
  pageType: PageType;
  productId?: number;
  offerId?: number;
  seid?: string | number;
  eventId?: number;
  shopId?: number;
};

class CustomerPayload {
  readonly id: string;

  constructor(id: string) {
    this.id = id;
  }
}

export class PageViewPayload {
  // Base props
  readonly time: number;
  readonly salesChannel: string;
  readonly url: string;
  readonly pageType: PageType;
  readonly duuid?: string;
  readonly customer?: CustomerPayload;

  // Product context
  readonly productId?: number;
  readonly offerId?: number;
  readonly seid?: string | number;

  // Event context
  readonly eventId?: number;

  // Shop context
  readonly shopId?: number;

  constructor({
    salesChannel,
    customerUuid,
    pageType,
    productId,
    offerId,
    shopId,
    eventId,
  }: PageViewPayloadParams) {
    this.time = parseInt(`${Date.now() / 1000}`);
    this.salesChannel = salesChannel;
    this.pageType = pageType;
    this.url =
      typeof location !== "undefined"
        ? location.href.replace(location.search, "")
        : "";
    this.duuid = Cookies.get("did");
    this.customer = customerUuid
      ? new CustomerPayload(customerUuid)
      : undefined;
    this.productId = productId;
    this.offerId = offerId;
    this.shopId = shopId;
    this.eventId = eventId;
    if (productId) {
      this.seid = -1;
    }
  }
}
